export default __webpack_public_path__ + "static/media/7Auwp_0qiz-afTLGLQ.6ea680ae.woff2";